import { render } from "./VideoDetailsWatchCompletionButton.vue?vue&type=template&id=479a1317&ts=true"
import script from "./VideoDetailsWatchCompletionButton.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsWatchCompletionButton.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__